module.exports = __webpack_public_path__ + "img/overlay_background.d1266f55.png";